(function () {
  var root = document.querySelector('[data-pcs-filter]');
  if (!root) return;

  /* Karten mit Rueckseite: Das Theme (main.js) erwartet bei zwei Bildern die Blaettern-Knoepfe und bricht sonst mit einem Skriptfehler ab.
     Wir legen sie unsichtbar an. So funktioniert auch das Wischen am Handy (Vorder-/Rueckseite) wie in der normalen Kollektion. */
  var grid = root.querySelector('[data-pcs-filter-grid]');
  if (grid) {
    var stub = '<button type="button" class="image-page-button image-page-button--previous" style="display:none" tabindex="-1" aria-hidden="true"></button><button type="button" class="image-page-button image-page-button--next" style="display:none" tabindex="-1" aria-hidden="true"></button>';
    var patch = function (b) {
      if (!b || b.nodeType !== 1 || b.tagName !== 'PRODUCT-BLOCK' || b.querySelector('.image-page-button--next')) return;
      var c = b.querySelector('.image-cont--with-secondary-image');
      if (c && b.querySelectorAll('.product-block__image').length > 1) c.insertAdjacentHTML('beforeend', stub);
    };
    new MutationObserver(function (list) { list.forEach(function (m) { m.addedNodes.forEach(patch); }); }).observe(grid, { childList: true });
    grid.querySelectorAll('product-block').forEach(patch);
    // Beim Antippen/Wischen am Handy die Rueckseite sofort laden
    grid.addEventListener('touchstart', function (e) {
      var b = e.target.closest && e.target.closest('product-block');
      var i = b && b.querySelector('img[data-pcs-src]');
      if (!i) return;
      if (i.dataset.pcsSrcset) i.srcset = i.dataset.pcsSrcset;
      i.src = i.dataset.pcsSrc;
      i.removeAttribute('data-pcs-src');
      i.removeAttribute('data-pcs-srcset');
    }, { passive: true });
  }

  if (!window.__pcsRel) { document.documentElement.classList.add('pcs-rel-fail'); return; }
  var handle = root.dataset.collection;
  function fix(t) {
    t = String(t || '');
    return t === t.toUpperCase() && t !== t.toLowerCase() ? t.toLowerCase().replace(/(^|\s)(\S)/g, function (m, a, b) { return a + b.toUpperCase(); }) : t;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(u, w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function href(h) { return '/collections/' + encodeURIComponent(h); }
  function failed() { document.documentElement.classList.add('pcs-rel-fail'); }
  window.__pcsRel.then(function (d) {
    if (!d || d.collection !== handle) { failed(); return; }
    var counts = d.counts || {};
    var sim = (d.similar || []).filter(function (k) { return k.h !== handle; });
    // Unterkategorien: vorhandene, von Hand gepflegte Links der Seite uebernehmen, sonst die berechneten
    var items = [];
    document.querySelectorAll('.related-collection-links--buttons a').forEach(function (a) {
      var m = /\/collections\/([^\/?#]+)/.exec(a.getAttribute('href') || '');
      if (m) items.push({ h: decodeURIComponent(m[1]), t: a.textContent.trim() });
    });
    if (!items.length) items = (d.kids || []).slice(0, 12).map(function (k) { return { h: k.h, t: k.t }; });
    items = items.filter(function (k) { return k.h !== handle; });
    var utility = root.querySelector('[data-pcs-utility]');
    if (items.length && utility && utility.parentNode && !document.querySelector('[data-pcs-sub]')) {
      var nav = document.createElement('nav');
      nav.className = 'pcs-sub';
      nav.setAttribute('data-pcs-sub', '');
      nav.setAttribute('aria-label', 'Unterkategorien');
      nav.innerHTML = items.map(function (k) {
        return '<a class="pcs-chip" href="' + href(k.h) + '">' + esc(fix(k.t)) + (counts[k.h] ? '<span class="pcs-chip__n">' + counts[k.h] + '</span>' : '') + '</a>';
      }).join('');
      utility.parentNode.insertBefore(nav, utility);
    } else if (!items.length) {
      failed();
    }
    if (sim.length && !root.querySelector('[data-pcs-related]')) {
      var box = document.createElement('div');
      box.className = 'container pcs-related';
      box.setAttribute('data-pcs-related', '');
      box.innerHTML = '<h2 class="pcs-related__title heading-font h3">Ähnliche Kategorien</h2><div class="pcs-related__row">' + sim.map(function (k) {
        var im = k.i ? '<img loading="lazy" decoding="async" alt="" src="' + esc(sized(k.i, 360)) + '" srcset="' + esc(sized(k.i, 240)) + ' 240w, ' + esc(sized(k.i, 360)) + ' 360w, ' + esc(sized(k.i, 540)) + ' 540w" sizes="(max-width: 749px) 44vw, 16vw">' : '';
        return '<a class="pcs-tile" href="' + href(k.h) + '"><span class="pcs-tile__img">' + im + '</span><span class="pcs-tile__name">' + esc(fix(k.t)) + '</span><span class="pcs-tile__count">' + k.n + ' Teile</span></a>';
      }).join('') + '</div>';
      root.appendChild(box);
    }
  });
})();
